/**
 * Home API — Dismiss a home card.
 *
 * POST /v1/home/:publicId/dismiss
 *
 * `publicId` is the underlying ContentRecord public id. Permanent, server-side,
 * set-once per user (recorded in the shared UserItemInteraction store keyed on
 * itemType='home_card', itemKey=publicId). Idempotent: re-dismiss is a success.
 */

import { z } from 'zod'

export const DismissHomeCardParamsSchema = z.object({
  publicId: z.string().min(1)
})

export type DismissHomeCardParams = z.infer<typeof DismissHomeCardParamsSchema>

export const DismissHomeCardResponseSchema = z.object({
  publicId: z.string(),
  dismissedAt: z.string().datetime()
})

export type DismissHomeCardResponse = z.infer<typeof DismissHomeCardResponseSchema>
